<template lang="pug">
  v-data-table(
    hide-default-footer,
    must-sort,
    v-bind="$attrs",
    :class="[noSpace ? 'pa-0' : 'py-3 py-5']",
    :headers="headers",
    :items="items",
    :sort-by.sync="misc.sortBy",
    :sort-desc.sync="misc.sortDesc",
    @update:sort-desc="$emit('sort', misc)",
  ) 
    template(v-slot:item="{ item, index }")
      slot(
        :item="item",
        :index="index",
        :headers="headers",
        :misc="misc",
      )
</template>

<script>
import { propOr, map, mergeRight } from 'ramda';
import * as tables from '@/constant/table';

export default {
  props: {
    misc: {
      type: Object,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    type: {
      type: String,
      default: '',
    },

    noSpace: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    headers() {
      const headerDisplay = this.$t(`table.${this.type}`);

      return map(header => {
        const text = header.value !== '' ? headerDisplay[header.value] : '';

        return mergeRight(header, { text });
      }, propOr([], 'headers', tables[this.type]));
    },
  },

  created() {
    // trigger fetch here
    this.$emit('sort', this.misc);
  },
};
</script>

<style lang="scss">
.v-data-table-header__icon {
  font-size: 12px !important;
  margin-left: 4px;
}
</style>
